'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = apiMiddleware;
function isPromise(value) {
  return value && typeof value.then === 'function';
}

var CALL_API = exports.CALL_API = '@@meadow/CALL_API';

function apiMiddleware(_ref) {
  var dispatch = _ref.dispatch;

  return function (next) {
    return function (action) {
      var definition = action[CALL_API];

      if (!definition) {
        return next(action);
      }

      var types = definition.types,
          meta = definition.meta,
          promise = definition.promise;

      var _types = _slicedToArray(types, 3),
          REQUEST = _types[0],
          SUCCESS = _types[1],
          FAILURE = _types[2];

      if (!isPromise(promise)) {
        return next(action);
      }

      if (!Array.isArray(types) || types.length !== 3) {
        throw new Error('API requests must have exactly 3 action types');
      }

      dispatch({
        type: REQUEST,
        meta: meta
      });

      return promise.then(function (data) {
        dispatch({
          type: SUCCESS,
          payload: data,
          meta: meta
        });

        return data;
      }, function (err) {
        dispatch({
          type: FAILURE,
          payload: err,
          error: true,
          meta: meta
        });

        throw err;
      });
    };
  };
}